import React from 'react';
import BulkSummaryHeader from 'src/components/BulkOperations/_Shared/BulkSummaryHeader/BulkSummaryHeader';

interface ImportSuccessBodyProps {
  importResult: { totalRecords: number } | null;
  entityName?: string;
  successMessage?: string;
}

const ImportSuccessBody = ({
  importResult,
  entityName = 'record',
  successMessage,
}: ImportSuccessBodyProps) => {
  const totalRecords = importResult?.totalRecords ?? 0;
  const plural = totalRecords !== 1 ? 's' : '';

  const capitalizedEntity =
    entityName.charAt(0).toUpperCase() + entityName.slice(1);

  const subtitle = (
    <>
      <strong>{totalRecords}</strong> {entityName}
      {plural} {successMessage || 'imported successfully.'}
    </>
  );

  return (
    <BulkSummaryHeader
      title={`${capitalizedEntity}${plural} Imported Successfully!`}
      subtitle={subtitle}
      centered={false}
    />
  );
};

export default ImportSuccessBody;
